import styled from "styled-components";

export const Content = styled.div`
  display: block;
  min-height: 600px;
  width: 100%;
  max-width: 90%;
  background-color: #fff;
  background-size: contain;
  border-radius: 10px;
  padding: 10px 20px 20px;
  margin-bottom: 20px;

  @media (max-width: 500px) {
    background-image: none;
  }

  button {
    margin-left: 5px;
  }
`;

export const LocalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
`;

export const Title = styled.h2`
  color: #01509C;
  font-size: 30px;
  font-weight: bold;
`;